export const ANALYTICS_CONSENT_KEY = 'analytics_consent';
export const ANALYTICS_CONSENT_GRANTED = 'granted';
export const ANALYTICS_CONSENT_DENIED = 'denied';

const GA_SCRIPT_ID = 'google-analytics-script';
const CLARITY_SCRIPT_ID = 'microsoft-clarity-script';

let analyticsInitialized = false;

export function getAnalyticsConsent() {
  try {
    return window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(value) {
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch {
    return;
  }

  window.dispatchEvent(new CustomEvent('analytics-consent-changed', { detail: value }));
}

export function hasAnalyticsConsent() {
  return getAnalyticsConsent() === ANALYTICS_CONSENT_GRANTED;
}

export function initializeAnalytics() {
  if (analyticsInitialized || !hasAnalyticsConsent()) {
    return;
  }

  initializeGoogleAnalytics();
  initializeMicrosoftClarity();
  analyticsInitialized = true;
}

export function trackPageView(pathname, search = '') {
  if (!hasAnalyticsConsent()) {
    return;
  }

  initializeAnalytics();

  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (gaMeasurementId && typeof window.gtag === 'function') {
    window.gtag('config', gaMeasurementId, {
      page_path: `${pathname}${search}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}

export function resetAnalyticsForTests() {
  analyticsInitialized = false;
}

function initializeGoogleAnalytics() {
  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaMeasurementId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaMeasurementId)}`;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', gaMeasurementId, { send_page_view: false });
}

function initializeMicrosoftClarity() {
  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (!clarityProjectId) {
    return;
  }

  window.clarity = window.clarity || function clarity() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  if (!document.getElementById(CLARITY_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = CLARITY_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${encodeURIComponent(clarityProjectId)}`;
    document.head.appendChild(script);
  }

  window.clarity('consent');
}
